import { render, staticRenderFns } from "./trigger-click.vue?vue&type=template&id=d4b65142&"
import script from "./trigger-click.vue?vue&type=script&lang=js&"
export * from "./trigger-click.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports